import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImport2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImport2"><Path d="M17 4C13.6863 4 11 6.68629 11 10V12.5858L8.25003 9.83579L6.83582 11.25L12 16.4142L17.1642 11.25L15.75 9.83579L13 12.5858V10C13 7.79086 14.7909 6 17 6H22V4H17Z" fill="currentColor"/><Path d="M2 4V20H22V8H20V18H4V6H9V4H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImport2;
